import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from './Button';
import { CloseChartIcon, DangerIcon } from './svgIcon';

function DeleteModal({
  status, closeModal, okFunction, title, subTitle, subTitle1, buttonLabel, buttonCancel, loading,
}) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  // Trigger the sliding effect when the modal opens or closes
  useEffect(() => {
    setIsOpen(status);
  }, [status]);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: isOpen ? 'translate(-50%, -50%)' : 'translate(100%, -50%)', // Slide in from right
    bgcolor: 'background.paper',
    border: '0.2px solid #bab8b8',
    boxShadow: 24,
    borderRadius: '10px',
    padding: '20px',
    overflowY: 'scroll',
    transition: 'transform 0.5s ease-out', // Apply the slide effect using transition
  };

  return (
    <Modal
      open={status}
      onClose={() => closeModal(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className="modal-box">
          <div className="delete-header-box">
            <div className="delete-danger-icon">
              <DangerIcon />
            </div>
            <div
              className="delete-close-button"
              role="presentation"
              onClick={() => closeModal(false)}
            >
              <CloseChartIcon />
            </div>
          </div>
          <div className="modal-header-title">
            <h1 className="modal-title">{title}</h1>
            <p className="modal-body-content">{subTitle}</p>
            <p className="modal-body-content">{subTitle1}</p>
          </div>
          <div className="modal-delete-buttons">
            <Button
              id="cancel"
              classes="default-button"
              click={() => closeModal(false)}
              label={!buttonCancel ? t('deleteBack') : buttonCancel}
            />
            <Button
              id={buttonLabel}
              classes="danger-button"
              click={okFunction}
              label={buttonLabel}
              loading={loading}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}

DeleteModal.propTypes = {
  status: PropTypes.bool,
  closeModal: PropTypes.func.isRequired,
  okFunction: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  subTitle1: PropTypes.string,
  buttonLabel: PropTypes.string.isRequired,
  buttonCancel: PropTypes.string,
  loading: PropTypes.bool.isRequired,
};

DeleteModal.defaultProps = {
  subTitle: '',
  status: false,
  subTitle1: '',
  buttonCancel: '',
};

export default DeleteModal;
